import { scrollTo } from 'scroll-js';
const sellingButton = document.getElementById('selling-btn');

// scrollTo(document.body, { top: 0 }).then(function () {
//     if (sellingButton) {
//         sellingButton.classList.add("hidden");
//     }
// });
//
// scrollTo(document.body, { top: 50 }).then(function () {
//     if (sellingButton) {
//         sellingButton.classList.remove("hidden");
//     }
// });

const myScrollFunc = function() {
    const y = window.scrollY;
    if (y >= 50) {
        sellingButton.classList.remove("hidden");

    } else {
        sellingButton.classList.add("hidden");
    }
};

window.addEventListener("scroll", myScrollFunc);
